import React, { useEffect, useState } from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { FormAddSlider } from "./FormAddSlider";
import { api_Routes } from "../../../tools/api_Routes";
import { Helper } from "../../../tools/Helper";

export const PanelAddSlider = () => {
  const [isCategoriesLoading, setCategoriesLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const getCategories = async () => {
    setCategoriesLoading(true);
    const { response, message } = await Helper.Get({
      url: `${api_Routes.Categories.ViewAll}`,
      hasToken: true,
    });
    if (response) {
      setCategories(response?.data);
    }
    setCategoriesLoading(false);
  };
  useEffect(() => {
    getCategories();
  }, []);
  return (
    <div>
      {" "}
      <PanelHead
        title={
          <div className="flex items-center justify-between w-full gap-4">
            <div>Add Slider</div>
          </div>
        }
      />
      <PanelBody
        content={
          <FormAddSlider
            categories={categories}
            isCategoriesLoading={isCategoriesLoading}
          />
        }
      />
    </div>
  );
};
